/* @flow strict */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import ReferralCreate from './referralCreate';
import ReferralDetail from './referralDetail';
import { POST } from '/client/src/api';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

import '../styles.scss';

type PropsType = {
  handleClose: (boolean) => void
};

const ReferralForm = ({ handleClose }: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const [step, setStep] = React.useState(1);
  const [referrals, setReferrals] = React.useState([]);
  const [isSubmitActive, setSubmitActive] = React.useState(false);
  const [isPending, setPending] = React.useState(false);


  React.useEffect(() => {
    const validRefferals = getValidRefferals(referrals);

    setSubmitActive(!!_.size(validRefferals));
  }, [referrals]);


  const submit = async () => {
    try {
      setPending(true);
      await POST('/api/v1/1/referrals/', {
        referrals: getValidRefferals(referrals)
      });

      context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Successfully saved'
      });

      setTimeout(() => {
        setPending(false);
        setStep(2);
      }, 2000);
    } catch (e) {
      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'Can\'t save refferals'
      });
      setPending(false);
    }
  };
  const getValidRefferals = (): any => {
    if (referrals.some((r: any): any => !r.isEmailValid || !r.isNameValid)) { // unfinished refferal data
      return null;
    }
    return referrals.reduce((refs, r: any): any => {
      if (r.name && r.email) {
        refs.push({ name: r.name, email: r.email });
      }
      return refs;
    }, []);
  };

  return (
    <Modal
      opened
      ignoreOutsideClick
      altView
      onClose={handleClose}
    >
      <div className="modal-dialog customModal WellcomeModal referralModal" role="document">
        <div className="modal-content">
        <div className="modal-header_container">
          <h3>Refer an Event Producer</h3>
          <h4>
              Receive a <b>$200.00</b> referral bonus for every referred event producer that sells over 200 tickets.
          </h4>
          </div>
          <div className="modal-body">
            {step === 1 ?
              <ReferralCreate handleSetReferrals={setReferrals} />
              :
              <ReferralDetail referrals={referrals} />
            }
          </div>
        </div>

        <div className="modal-footer">
          <div className='modal-footer_container'>

            {step === 1 ?
            <>
                <button
                  data-type='outline-with-border'
                  className="btn btn-gray"
                  onClick={(): void => handleClose()}
                >Close</button>
              <button
                className={`btn btn-pink ${isSubmitActive ? '' : 'submit-btn__disabled'}`}
                onClick={(): void => submit()}
              >
                Refer
              </button>
              </> :
              <button
                className="btn btn-pink"
                onClick={(): void => handleClose()}
              >
                Close
              </button>
            }
          </div>
        </div>
        {
          isPending && <span className='csspinner' />
        }
      </div>
    </Modal>
  );
};

export default ReferralForm;
